import { $api } from "../generated/client";

/** `isEnabled`: only while the carrier banner can actually show. */
export const useGetCustomerCarrierPortalLink = (
  shopId: string,
  isEnabled = true,
) => {
  return $api.useQuery(
    "get",
    "/shops/{shopId}/billings/carrier-setup-link",
    { params: { path: { shopId } } },
    { enabled: isEnabled && !!shopId },
  );
};
